import { render, staticRenderFns } from "./SicknessOutput.vue?vue&type=template&id=004e26d4"
import script from "./SicknessOutput.vue?vue&type=script&lang=js"
export * from "./SicknessOutput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports